// extracted by mini-css-extract-plugin
export default {"moreMenu":"Hvw1Vu4NWZy_9I5eWtqq","deleteRowMenuItem":"d521v3ds_q13Z45cJLVN","wrapper":"qCJISGZ6VkksN9VRee54","label":"NPirEA3Il_cEQ0TdgcSz","isAddNewRole":"XzAb_F8NBbszKnw4Eme5"};